module.exports = __webpack_public_path__ + "resources/img/logo_nhn_cloud_m_ngsc.611297cd86c288f8823026a33baddf24.svg";